<template>
    <div class="p-20" style="width: calc(100% - 315px)">
        <div class="title bg-default px-20 pt-16">
            <div class="title">
                工会日报数据
            </div>
            <el-form :model="form" :inline="true" size="small" label-width="41px" class="mt-20">
                <el-form-item label="日期">
                    <el-date-picker v-model="form.startTime" :picker-options="pickerOptions"  type="date" value-format="yyyy-MM-dd" style="width: 200px" />
                </el-form-item>
                <el-form-item label="至">
                    <el-date-picker v-model="form.endTime" :picker-options="pickerOptions"  type="date" value-format="yyyy-MM-dd" style="width: 200px" />
                </el-form-item>
                <el-form-item label="">
                    <el-button :disabled="loading" @click="search" type="primary" class="flex-x-end">
                        查询
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="flex-x-between">
            <div class="mt-20 bg-default col-11 p-20">
                <div class="title report-title">
                    {{ tableList[0].name }}
                </div>
                <idc-table element-loading-text="拼命加载中" v-loading="loading"  :data="tableList[0].data" :column="tableList[0].column" :checkbox="false" />
            </div>
            <div class="mt-20 bg-default col-11 p-20">
                <div class="title report-title">
                    {{ tableList[1].name }}
                </div>
                <idc-table element-loading-text="拼命加载中" v-loading="loading"  :data="tableList[1].data" :column="tableList[1].column" :checkbox="false" />
            </div>

        </div>
        <div>
            <div class="mt-20 bg-default col-14 p-20">
                <div class="title report-title">
                    {{ tableList[2].name }}
                </div>
                <idc-table element-loading-text="拼命加载中" v-loading="loading"  :data="tableList[2].data" :column="tableList[2].column" :checkbox="false" />
            </div>
        </div>
    </div>
</template>

<script>
import { Loading } from 'element-ui';
export default {
    data() {
        return {
            loading:true,
            form: {},
            pickerOptions: {
                disabledDate(time) {
                    return  time.getTime() >= new Date(new Date().setHours(0, 0, 0, 0));
                }
            },
            tableList: [
                {
                    name: '当日已支付订单量，成交金额',
                    column: [
                        { labourOrderTypeStr: '工会订单类型' },
                        { payOrderTotalNumDay: '已支付订单（笔）' },
                        { payOrderTotalAmountDay: '已支付金额（万元）' }
                    ],
                    data: []
                },
                {
                    name: '当日订单量，成交金额',
                    column: [
                        { labourOrderTypeStr: '工会订单类型' },
                        { orderTotalNumDay: '当日订单（笔）' },
                        { orderTotalAmountDay: '当日订单金额（万元）' }
                    ],
                    data: []
                },
                {
                    name: '小程序日报数据',
                    column: [
                        { dayTradeAmount: '日交易额（万元）' },
                        { dayOrderNum: '日订单量（笔）' },
                        { dayMoneyPayOrderNum: '日实付订单量（笔）' },
                        { dayCollectionOrderAmount: '日优惠额（万元）' },
                        { dayCollectionOrderNum: '日集采分发订单量（笔）' }
                    ],
                    data: []
                }
            ]
        };
    },
    computed: {

    },
    created() {
        const yesterday = new Date(new Date().getTime() - 3600 * 24 * 1000);
        this.form.startTime = yesterday.getFullYear() + '-' + String(yesterday.getMonth() + 1).padStart(2, 0) + '-' + String(yesterday.getDate()).padStart(2, 0);
        this.form.endTime = yesterday.getFullYear() + '-' + String(yesterday.getMonth() + 1).padStart(2, 0) + '-' + String(yesterday.getDate()).padStart(2, 0);
        this.form = JSON.parse(JSON.stringify(this.form));
        this.search();
    },
    methods: {
        getLabourOrderTypeStr(arr){
            arr.forEach(function (item){
                if(item.labourOrderType === 2){
                    item.labourOrderTypeStr = "统一送货（立即送货）";
                }else if(item.labourOrderType === 3){
                    item.labourOrderTypeStr = "统一送货（指定时间送货）";
                }else if(item.labourOrderType === 4){
                    item.labourOrderTypeStr = "兑换码自主兑换";
                }else if(item.labourOrderType === 99){
                    item.labourOrderTypeStr = "合计";
                }
            });
        },
        search() {
            if(!this.form.startTime){
                this.$message.error("请选择开始日期");
                return;
            }else if(!this.form.endTime){
                this.$message.error("请选择结束日期");
                return;
            }else if(new Date(this.form.endTime).getTime() - new Date(this.form.startTime).getTime() < 0){
                this.$message.error("结束日期不能小于开始日期");
                return;
            }else if(new Date(this.form.endTime).getTime() - new Date(this.form.startTime).getTime() > 1000*60*60*24*31){
                this.$message.error("日期范围不能大于31天");
                return;
            }
            this.loading = true;
            this.$http.post('/basic/labourBusiness/day/report', { timeStart: this.form.startTime,timeEnd: this.form.endTime}).then(res => {
                this.loading = false;
                const data = res.data || {labourOrderDayReportDtos:[],labourBusinessDayTocDto:{}};
                this.getLabourOrderTypeStr(data.labourOrderDayReportDtos);
                this.tableList[0].data = data.labourOrderDayReportDtos;
                this.tableList[1].data = data.labourOrderDayReportDtos;
                this.tableList[2].data = [data.labourBusinessDayTocDto];
                if(!res.data){
                    this.$message.error(res.message);
                }
            });
        },
        getDateVal(time) {
            const date = new Date(time);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, 0);
            const day = String(date.getDate()).padStart(2, 0);
            return `${year}-${month}-${day}`;
        }
    }
};
</script>
<style scoped lang="css">
.report-title {
    margin-bottom: 20px;
}
</style>
